import { Chip } from "~/components/chip";
import { ExceptionGroup, ExceptionMutationAction } from "~/operations";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import { FalsePositiveIcon, WorkaroundIcon } from "~/icons";

export function ExceptionTypeChip({
  action,
}: {
  action: ExceptionGroup["action"];
}) {
  // isRiskAccepted is the default option.  leaving commented for posterity
  //   const isRiskAccepted = action === ExceptionMutationAction.RiskAccepted;
  const isWorkaround = action === ExceptionMutationAction.Workaround;
  const isFalsePositive = action === ExceptionMutationAction.FalsePositive;
  const isDisabled = action === ExceptionMutationAction.Disable;

  //default to risk Accepted
  let eType = {
    label: "Risk accepted",
    icon: <ThumbUpOffAltIcon />,
  };

  if (isWorkaround) {
    eType = {
      label: "workaround",
      icon: <WorkaroundIcon />,
    };
  }

  if (isFalsePositive) {
    eType = {
      label: "False positive",
      icon: <FalsePositiveIcon />,
    };
  }

  if (isDisabled) {
    eType = {
      label: "Disabled",
      icon: <BlockOutlinedIcon />,
    };
  }

  return (
    <Chip
      label={eType.label}
      icon={eType.icon}
      size="small"
      data-testid={`chip-${eType.label.split(" ").join("-")}`}
    />
  );
}
